import { render, staticRenderFns } from "./OrderNum.vue?vue&type=template&id=f8d9aa1e&scoped=true"
import script from "./OrderNum.vue?vue&type=script&lang=js"
export * from "./OrderNum.vue?vue&type=script&lang=js"
import style0 from "./OrderNum.vue?vue&type=style&index=0&id=f8d9aa1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d9aa1e",
  null
  
)

export default component.exports